import { useState, useCallback, ChangeEvent } from 'react';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';
import { emailChecker } from '@utils/common/validators';

const PasswordFindPopup = ({ popupHandler }: { popupHandler: (isOpen: boolean) => void }) => {
  const [emailText, setEmailText] = useState('');
  const [responseResult, setResponseResult] = useState(null);

  const onChangeEmail = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;
    setEmailText(value);
  }, []);

  // 패스워드 요청
  const requestForgetPassword = useCallback(async () => {
    if (emailChecker(emailText)) {
      const { data, status, statusText } = await axiosDummyInstance.get('api/auth/passwordFindERROR.json');
      if (status === 200) {
        console.log('data: ', data);
        setResponseResult(data);
      } else {
        alert(`${statusText} error occured ask administrator for this`);
      }
    } else {
      alert('email form is invalid');
    }
  }, [emailText, axiosDummyInstance, emailChecker]);

  // 팝업창 닫기
  const onClosePopup = useCallback(() => {
    // 초기화 처리
    setEmailText('');
    setResponseResult(null);
    popupHandler(false);
  }, [popupHandler]);

  return (
    <div className="lpopup-wrap">
      <div className="lpopup-content lpopup-lsmallsize">
        <h2 className="lpopup-tit">Insert Email to Find Your Password</h2>
        <div className="lpopup-container">
          <div className="lpopup-tbl-inner">
            <table className="lpopup-tbl-2">
              <colgroup>
                <col width="25%" />
                <col width="" />
              </colgroup>
              <tbody>
                <tr>
                  <th className="left">Email</th>
                  <td>
                    <label className="ipt type-gray">
                      <input type="text" name="team" value={emailText} onChange={onChangeEmail} />
                    </label>
                  </td>
                </tr>
                {responseResult && (
                  <tr>
                    <th className="left">Result</th>
                    <td>
                      <span
                        className={`password-find-popup-${responseResult?.responseStatus === '200' ? 'ok' : 'error'}`}
                      >
                        {responseResult?.result}
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="lpopup-btn">
            <button
              type="button"
              disabled={emailText.trim().length > 0 ? false : true}
              className={`btn ${emailText.trim().length > 0 ? 'pri' : ''}`}
              onClick={requestForgetPassword}
            >
              Confirm
            </button>
          </div>
        </div>
        <button type="button" className="lpopup-close" onClick={onClosePopup}>
          <span className="blind">닫기</span>
        </button>
      </div>
    </div>
  );
};

export default PasswordFindPopup;
